/* Rippin Moto collection page: client-side "Fits my bike" filter and
   sub-category chip filter. Vanilla JS, no dependencies. Reads the
   rm_bike value a customer's picked from localStorage (set by the header
   bike picker and the bike pages) and matches it against each card's
   data-fits attribute (a space-separated list of bike handles).
   Sub-category chips match a card's data-sub attribute. Both filters
   combine: a card only shows when it passes both.

   The bike filter is ON by default whenever a bike is stored and the page
   has fitment data. A rider turning it off is remembered for the session in
   sessionStorage (rm_bike_filter_off) so it stays off on every collection
   page until they pick a bike again or turn it back on. */
(function () {
  var OFF_KEY = 'rm_bike_filter_off';

  function readStorage(store, key) {
    try {
      return window[store].getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function writeStorage(store, key, value) {
    try {
      if (value === null) window[store].removeItem(key);
      else window[store].setItem(key, value);
    } catch (e) {
      /* storage unavailable; the filter still works for this page load */
    }
  }

  function currentBike() {
    return readStorage('localStorage', 'rm_bike');
  }

  /* Gas bikes from the header picker (data-bike-kind="gas") have no
     fitment data on any product yet, so the filter would hide every card.
     For them the filter starts off; the rider can still turn it on. */
  function isGasBike(handle) {
    if (!handle) return false;
    var safe = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/["\\]/g, '');
    var opt = document.querySelector('[data-bike-handle="' + safe + '"][data-bike-kind]');
    return !!(opt && opt.getAttribute('data-bike-kind') === 'gas');
  }

  function openPicker() {
    document.dispatchEvent(
      new CustomEvent('rm:bike-picker-open', { detail: { source: 'collection' } })
    );
  }

  function init(root) {
    var wrap = root.querySelector('[data-rm-bike-filter]');
    var toggle = root.querySelector('[data-rm-bike-toggle]');
    var toggleLabel = root.querySelector('[data-rm-bike-toggle-label]');
    var changeBtn = root.querySelector('[data-rm-bike-change]');
    var showAllBtn = root.querySelector('[data-rm-bike-show-all]');
    var status = root.querySelector('[data-rm-bike-status]');
    var results = root.querySelector('results-list');
    var chips = root.querySelectorAll('.rm-fchip');
    var collectionHandle = results ? results.getAttribute('data-rm-collection') || '' : '';

    var labels = {
      on: (wrap && wrap.getAttribute('data-label-on')) || 'Fits my [bike]',
      off: (wrap && wrap.getAttribute('data-label-off')) || 'Show only parts for my [bike]',
      none: (wrap && wrap.getAttribute('data-label-none')) || 'Choose your bike to filter',
    };
    var showAllText = showAllBtn ? showAllBtn.textContent.trim() || 'Show all' : 'Show all';

    var filterOn = false;

    function cards() {
      return root.querySelectorAll('.product-grid__item');
    }

    function hasFitData() {
      var list = cards();
      for (var i = 0; i < list.length; i++) {
        if ((list[i].getAttribute('data-fits') || '').trim()) return true;
      }
      return false;
    }

    function bikeLabel() {
      var b = currentBike();
      if (!b) return '';
      var opt = document.querySelector('[data-bike-handle="' + b + '"]');
      return (opt && opt.getAttribute('data-bike-label')) || b;
    }

    /* "[bike]" in a label becomes the bike name. A label saved before the
       placeholder existed ("Fits my bike") gets its trailing "bike" swapped;
       anything else gets the name appended. */
    function fillLabel(tpl, name) {
      if (tpl.indexOf('[bike]') !== -1) return tpl.replace('[bike]', name);
      if (/\bbike\s*$/i.test(tpl)) return tpl.replace(/\bbike\s*$/i, name);
      return tpl + ' ' + name;
    }

    function activeSub() {
      var pressed = root.querySelector('.rm-fchip[aria-pressed="true"]');
      return pressed ? pressed.getAttribute('data-rm-sub') : '';
    }

    function setStatus(text, withShowAll) {
      if (!status) return;
      status.textContent = '';
      if (!text) {
        status.hidden = true;
        return;
      }
      status.hidden = false;
      status.appendChild(document.createTextNode(text));
      if (withShowAll) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rm-bike-link';
        btn.textContent = showAllText;
        btn.addEventListener('click', function () {
          riderToggle(false);
        });
        status.appendChild(document.createTextNode(' '));
        status.appendChild(btn);
      }
    }

    function applyFilters() {
      var bike = currentBike();
      var bikeOn = filterOn && !!bike;
      var sub = activeSub();
      var list = cards();
      var shown = 0;

      list.forEach(function (card) {
        var fits = (card.getAttribute('data-fits') || '').split(/\s+/).filter(Boolean);
        var cardSub = card.getAttribute('data-sub') || '';
        var passBike = !bikeOn || fits.indexOf(bike) !== -1;
        var passSub = !sub || cardSub === sub;
        card.hidden = !(passBike && passSub);
        if (!card.hidden) shown++;
      });

      var name = bikeLabel();
      var state = !bike ? 'none' : bikeOn ? 'on' : 'off';

      if (wrap) wrap.setAttribute('data-state', state);
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(state === 'on'));
        if (toggleLabel) {
          toggleLabel.textContent =
            state === 'none' ? labels.none : fillLabel(state === 'on' ? labels.on : labels.off, name);
        }
      }
      if (changeBtn) changeBtn.hidden = state === 'none';
      if (showAllBtn) showAllBtn.hidden = state !== 'on';

      if (state === 'on') {
        if (shown) {
          setStatus('Showing ' + shown + ' matching product' + (shown === 1 ? '' : 's') + ' on this page for ' + name + '.', false);
        } else {
          setStatus('No matching products are listed for this selection. Try another filter or contact us with your bike model, year, and setup.', true);
        }
      } else {
        setStatus('', false);
      }
    }

    function setBikeFilter(on) {
      filterOn = !!on;
      applyFilters();
    }

    function track(on) {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('rm_bike_filter', {
            on: !!on,
            bike: currentBike(),
            collection: collectionHandle,
          });
        }
      } catch (e) {
        /* analytics must never break the filter */
      }
    }

    /* A toggle made by the rider (not by a bike change) is remembered for
       the session and reported to analytics. */
    function riderToggle(on) {
      writeStorage('sessionStorage', OFF_KEY, on ? null : '1');
      setBikeFilter(on);
      track(on);
    }

    /* The header picker, bike pages and the homepage guide all dispatch this
       when the rider picks a bike. Picking one while browsing turns the
       filter on and forgets a session opt-out; clearing it turns the
       filter off. */
    document.addEventListener('rm:bike-change', function (ev) {
      var handle = ev && ev.detail ? ev.detail.handle || ev.detail.bike : null;
      if (handle) writeStorage('sessionStorage', OFF_KEY, null);
      setBikeFilter(!!handle && !isGasBike(handle));
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (!currentBike()) {
          openPicker();
          return;
        }
        riderToggle(!filterOn);
      });
    }
    if (changeBtn) changeBtn.addEventListener('click', openPicker);
    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () {
        riderToggle(false);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        applyFilters();
      });
    });

    /* Default: on when a bike is stored, the page has fitment data and the
       rider has not turned it off this session. */
    filterOn =
      !!currentBike() &&
      !isGasBike(currentBike()) &&
      hasFitData() &&
      readStorage('sessionStorage', OFF_KEY) !== '1';
    applyFilters();
  }

  document.querySelectorAll('results-list.rm-results').forEach(function (el) {
    init(el.closest('.rm-wrap') || el);
  });
})();

/* Collection description "Read more". The description is clamped to 3 lines on
   mobile; the button only appears when there is more text than fits, and it is
   left alone above 749px where the full description has room. */
(function () {
  var wrap = document.querySelector('[data-rm-desc]');
  if (!wrap) return;
  var body = wrap.querySelector('[data-rm-desc-body]');
  var btn = wrap.querySelector('[data-rm-desc-toggle]');
  if (!body || !btn) return;

  var moreLabel = btn.textContent.trim() || 'Read more';
  var lessLabel = 'Show less';
  var mq = window.matchMedia('(max-width: 749px)');

  function sync() {
    if (!mq.matches) {
      wrap.removeAttribute('data-rm-desc-clamped');
      btn.hidden = true;
      return;
    }
    wrap.setAttribute('data-rm-desc-clamped', 'true');
    var overflows = body.scrollHeight - body.clientHeight > 2;
    if (!overflows && btn.getAttribute('aria-expanded') !== 'true') {
      wrap.removeAttribute('data-rm-desc-clamped');
      btn.hidden = true;
    } else {
      btn.hidden = false;
    }
  }

  btn.addEventListener('click', function () {
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (open) {
      wrap.setAttribute('data-rm-desc-clamped', 'true');
      btn.textContent = moreLabel;
    } else {
      wrap.removeAttribute('data-rm-desc-clamped');
      btn.textContent = lessLabel;
    }
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
  sync();
})();
